module.exports = __webpack_public_path__ + "img/010001.66c97c82.png";